import React, { useEffect, useRef, useState } from "react";
import { Header } from "../styled/common";
import { IoRefresh, IoSearch } from "react-icons/io5";
import { IoIosRefresh, IoMdRefresh, IoMdSettings } from "react-icons/io";
import { IoClose, IoCloseOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import KioskCalendar from "./kioskCalendar";

const KioskHeader = ({
  title,
  handleSearch = null,
  searched = "",
  setSearched = null,
  dateRange = null,
  openCalendar = null,
  handleOpenCalendar = null,
  handleDateClick = null,
  handleResetDate = null,
  handleClickStorage,
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const user = useSelector((state) => state?.user?.data[0]);

  const parts = location.pathname.split("/");
  const service = parts[2] || "kiosk";
  const isSungsim = service === "kiosk";

  const resetButton = async () => {
    setSearched("");
    handleSearch(true);
  };

  return (
    <Header className={isSungsim ? "sungsim" : "baseball"}>
      <div className="tit">
        <span>
          {isSungsim ? "으능성심" : "빵다방"} {title}
        </span>
        {pathname.includes("storage") && (
          <button className="operation" onClick={() => handleClickStorage("storeSettings")}>
            <IoMdSettings />
          </button>
        )}
      </div>
      {pathname.includes("reservationStatus") && (
        <div className="date">
          <button onClick={() => handleOpenCalendar(true)}>
            {dateRange?.start && dateRange?.end
              ? `${dateRange.start}~${dateRange.end}`
              : "날짜 선택"}
          </button>
          {openCalendar && (
            <KioskCalendar
              handleDateClick={handleDateClick}
              handleOpenCalendar={handleOpenCalendar}
              dateRange={dateRange}
              handleResetDate={handleResetDate}
            />
          )}
        </div>
      )}
      {handleSearch && (
        <div className="searchForm">
          <input
            type="text"
            value={searched}
            onChange={(e) => setSearched(e.target.value)}
            onKeyDown={(e) => handleEnterKey(e, handleSearch)}
          />
          {searched && (
            <button className="reset" onClick={resetButton}>
              <IoCloseOutline />
            </button>
          )}
          <button onClick={() => handleSearch()} className="search">
            검색
          </button>
        </div>
      )}
      <div className="close">
        {(pathname.includes("pickup") || pathname.includes("coupon")) && (
          <button onClick={() => window.location.reload()}>
            <IoMdRefresh />
          </button>
        )}
        <button onClick={() => navigate(`/mypage/${service}`)}>
          <IoClose />
        </button>
      </div>
    </Header>
  );
};

export default KioskHeader;
